import React, { Component } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';

import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

import { connect } from 'react-redux';
import packetService from '../../../api/jobcoinsPacketService'
import { toDolarCurrency } from '../../../shared/helpers/numberFormat';
import { Button, CircularProgress } from '@material-ui/core';
import JobcoinsPacketFormModal from './JobcoinsPacketFormModal';
import { choosePacket, cleanPacket } from '../../../redux/actions/jobcoinsPacketActions';
import { bindActionCreators } from 'redux';
import ConfirmJobcoinsPacketDelete from './ConfirmJobcoinsPacketDelete';

class JobcoinsPacketScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isShowingForm: false,
            isShowingDeleteConfirmation: false,
            packetToEdit: null,
            loadingData: true
        };

        this.showForm = this.showForm.bind(this);
        this.hideForm = this.hideForm.bind(this);
        this.showConfirmation = this.showConfirmation.bind(this);
        this.hideConfirmation = this.hideConfirmation.bind(this);
    }

    async componentDidMount() {
        const { packets } = this.props;
        if (packets.length <= 0) {
            await packetService.getAllPackets();
        }
        this.setState({
            loadingData: false
        });
    }

    showForm() {
        this.setState({
            isShowingForm: true
        });
    }

    hideForm() {
        this.setState({
            isShowingForm: false,
        });

        this.props.cleanPacket();
    }

    showConfirmation() {
        this.setState({
            isShowingDeleteConfirmation: true
        });
    }

    hideConfirmation() {
        this.setState({
            isShowingDeleteConfirmation: false,
        });

        this.props.cleanPacket();
    }

    editPacket(packet) {
        this.props.choosePacket(packet);
        this.showForm();
    }

    deletePacket(packet) {
        this.props.choosePacket(packet);
        this.showConfirmation();
    }

    render() {
        const { packets } = this.props;

        if (this.state.loadingData) {
            return (
                <div style={{ display: 'flex', flex: 1, flexGrow: 1, height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress color="secondary" />
                </div>
            );
        }

        return (
            <div>
                <div style={{ textAlign: 'right' }}>
                    <Button color="secondary" variant="contained" onClick={this.showForm} >
                        <AddIcon style={{ marginRight: 10 }} /> Add new Jobcoins Packet
                    </Button>
                </div>
                <List>
                    {packets.map(packet => {
                        return (
                            <ListItem key={packet.id} role={undefined} dense button>
                                <ListItemIcon>
                                    <AttachMoneyIcon />
                                </ListItemIcon>
                                <ListItemText primary={`x${packet.totalCoins} Jobcoins Packet + ${packet.bonusCoins} Bonus Jobcoins`}
                                    secondary={`Total: ${packet.totalCoins + packet.bonusCoins} Jobcoins. Price: ${toDolarCurrency(packet.price)}`}
                                     />
                                <ListItemSecondaryAction>
                                    <IconButton onClick={() => {
                                        this.editPacket(packet);
                                    }} edge="end" aria-label="more">
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton edge="end" aria-label="more"
                                        onClick={() => {
                                            this.deletePacket(packet);
                                        }}>
                                        <DeleteIcon />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                        );
                    })}
                </List>
                <JobcoinsPacketFormModal showModal={this.state.isShowingForm}
                    hideModal={this.hideForm} />

                <ConfirmJobcoinsPacketDelete showConfirm={this.state.isShowingDeleteConfirmation}
                    onClose={this.hideConfirmation} />
            </div>
        );
    }
}

const mapStateToProps = store => ({
    packets: store.jobcoinsPacketState.packets
});

const mapDispatchToProps = dispatch => (
    bindActionCreators({ choosePacket, cleanPacket }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(JobcoinsPacketScreen);